import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	min-height: 56px;
	display: flex;
	align-items: center;
	padding: 0 8px 0 16px;
	box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);
`;

export const TitleWrapper = styled.div`
	font-size: 16px;
	color: ${colors.black};
`;

export const ButtonsWrapper = styled.div`
	display: flex;
	margin-left: auto;

	button {
		margin-left: 8px;
	}
`;
